import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import '@angular/localize/init';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

import { SearchModel } from '@app/models/search.model';
import { RankipediaService } from '@app/services/rankipedia.service';
import { UserService } from '@app/services/user.service';
import { AlertService, MessageSeverity } from '@app/services/alert.service';
import { isNullOrUndefined } from 'util';
import { AppHttpService } from '@app/services/app-http.service';

declare const Bloodhound;
declare const $;

// --------------------------------------------------------------//
// from rankipedia-type-ahead js
//  - strange sytax but only way to use the .js items in typescript without rewriting them all
//
// --------------------------------------------------------------//

// typeahead data sets
declare const specialties: any;
declare const keywords: any;
declare const professionals: any;
declare const locations: any;

// typeahead helper functions
declare const doSearch: any;
declare const formatNothingFoundSpecialties: any;
declare const formatNothingFoundProfessionals: any;
declare const onAutoCompleted: any;
declare const onSelected: any;
declare const popularSearches: any;
declare const searchNearby: any;
declare const setupSearch: any;

@Component({
  selector: 'ranki-app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  isLoading = false;
  searchTypeInit: string = '';
  initialSearchIn: string = '';
  specialtiesHeader: string = "";
  searchModel: SearchModel = new SearchModel("", "");
  @Input() minimode: boolean = false;
  @Output() closeEvent: EventEmitter<any> = new EventEmitter();

  constructor(
    private appHttp: AppHttpService,
    private router: Router,
    private route: ActivatedRoute,
    private _alertService: AlertService,
    private _rankiService: RankipediaService  ) {
  }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    setTimeout(() => {
      this.initializeTypeAhead();
    }, 500);
  }

  getDefaultLocation() {
    this.appHttp.getDefaultLocation().then(
      (data: string) => {
        if (data) {this.searchModel.searchIn = data; }
      }
    ).catch( err => console.log(err) );
  }

  initializeTypeAhead() {
    $('.typeahead-find').typeahead({
        highlight: true,
        hint: true,
        async: true,
        minLength: 0,
        limit: 5,
        debug: false,
        order: "asc",
      },
      {
        name: 'popularSearches',
        display: 'title',
        source: popularSearches,
        templates: {
          header: "<h3 class='search-header-text header-professionals'>Popular Searches</h3>",
        }
      },
      {
        name: 'specialty',
        display: 'title',
        source: specialties,
        templates: {
          header: "<h3 class='search-header-text header-professionals'>Industries</h3>",
          empty: function (data) {
            return formatNothingFoundSpecialties(data);
          }
        }
      },
      {
        name: 'professional',
        display: 'title',
        source: professionals,
        templates: {
          header: '<h3 class="search-header-text search-header-profs">Professionals</h3>',
          empty: function (data) {
            return formatNothingFoundProfessionals(data);
          }
        }
      },
      {
        name: 'keyword',
        display: 'title',
        source: keywords,
        templates: {
            header: '<h3 class="search-header-text">Keyword found in..</h3>'
        }
      }
    ).on('typeahead:selected', onSelected)
      .on('typeahead:autocompleted', onAutoCompleted)
      .on('typeahead:render', this.onSearchResultsRender);

    $('.typeahead-in').typeahead({
        highlight: true,
        hint: true,
        minLength: 1,
        limit: 4,
        debug: false,
        order: "asc",
        display: 'id',
    },
      {
        name: 'location',
        display: 'title',
        source: locations,
        templates: {
            header: '<h3 class="search-header-text">Locations</h3>'
        }
      }
    );

    if ((this.initialSearchIn == undefined) || (this.initialSearchIn == null) || (this.initialSearchIn == '')) {
      var addr = this.getDefaultLocation();
    }
    if (this.searchTypeInit != undefined) {
      setupSearch(this.searchTypeInit);
    }
    setTimeout(function () {
      $(function () {
        $(".btn-search").show();
      });
    }, 100);
  }

  onSearchResultsRender(event, suggestion, flag, name) {
    if (suggestion != undefined && suggestion.title != '' && suggestion.type == '12') {
      searchNearby(suggestion.title, suggestion.ind, suggestion.spec, suggestion.sub);
      $('.tt-missing').remove();
    }
  }

  setSpecialtiesHeader() {
    var elem = $('.typeahead-find');
    if (elem != undefined && elem != null && elem.length > 0) {
      console.log('.typeahead-find value: ' + elem[1].value);
      var hdrElem = $('.header-professionals');
      if (hdrElem.length > 0) {
        if (elem[1].value.length > 0) {
          this.specialtiesHeader = "Industries";
        }
        else {
          this.specialtiesHeader = 'Popular Searches';
        }
      }
    }
  }

  onKeyupSearchInput(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      doSearch();
    }
  }

  onDoSearch() {
    doSearch();
  }
}
